/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable promise/catch-or-return */

import { useState, useEffect, useContext } from 'react';
import UsageTrackerContext from 'automation-ui-usage-tracking/UsageTrackerContext';
import Trackables from 'automation-ui-usage-tracking/Trackables';
import { trackEvent } from 'automation-ui-usage-tracking/trackingUtils';
import UILoadingSpinnerCentered from 'automation-ui-formula-editor/components/common/UILoadingSpinnerCentered';
import { useDataFetchingClient } from 'data-fetching-client';
import { useDataPassingContext } from 'automation-ui-formula-editor/data-passing-panel/DataPassingContext';
import { useGetDataSource } from 'automation-ui-formula-editor/data-sources/hooks/useGetDataSource';
import DataPassingPanelHeader from 'automation-ui-formula-editor/data-passing-panel/DataPanelRevisedUXMode/DataPassingPanelHeader';
import DataPassingPanelBody from 'automation-ui-formula-editor/data-passing-panel/DataPanelRevisedUXMode/DataPassingPanelBody';
import { ACTION_OUTPUTS, ENROLLMENT_EVENTS, FETCHED_OBJECTS } from 'automation-ui-formula-editor/data-sources/constants/dataSourcesConstants';
import { GET_DATA_SOURCE_BY_PREFIX_FIELD_NAME, GET_DATA_SOURCES_BY_PREFIX_FIELD_NAME } from 'automation-ui-formula-editor/data-sources/queries/getPrefixQueries';
import { NEW_ACTION } from 'automation-ui-flow-core/canvas/SpecialActionIds';
import { getToObjectType } from 'automation-ui-formula-editor/data-passing-panel/utils/getToObjectType';
import DataPanelCreatePropertyButton from 'automation-ui-formula-editor/data-passing-panel/DataPanelRevisedUXMode/DataPanelCreatePropertyButton';
import ObjectTypePropertiesContext from 'automation-ui-references/object-type-properties/ObjectTypePropertiesContext';
import { useGetDataSourceFromToObjectId } from 'automation-ui-formula-editor/data-sources/hooks/useGetDataSourceFromToObjectId';
import { DEFAULT_ALLOWED_DATA_SOURCES } from 'automation-ui-formula-editor/data-sources/utils/isDataSourceAllowListed';
import { ScrollContainer } from 'foundations-components/transitional/components/ScrollContainer';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DataPanelRevisedUXMode = ({
  clearSearchForDataToken,
  isAddDataSourceBtnVisible = false,
  isEmbedded,
  lastAddedEditedDataSource = '',
  lastDeletedDataSource = '',
  onClosePanelClick,
  searchForDataToken
}) => {
  const dataFetchingClient = useDataFetchingClient();
  const {
    state: dataPassingState
  } = useDataPassingContext();
  const {
    usageTracker
  } = useContext(UsageTrackerContext);
  const {
    supportsCustomProperties
  } = useContext(ObjectTypePropertiesContext);
  const {
    actionId,
    onDataPropertySelected,
    previousActionId,
    openFetchObjectPanel,
    dataSourceAllowList,
    dataSourceBlockList = [],
    propertyFieldTypeAllowList,
    propertyTypeAllowList,
    requiredPermissionLevel,
    hideNestedDataSources,
    flowObjectTypeId,
    flowId
  } = dataPassingState;
  const filteredDataSourceAllowList = (dataSourceAllowList !== null && dataSourceAllowList !== void 0 && dataSourceAllowList.length ? dataSourceAllowList : DEFAULT_ALLOWED_DATA_SOURCES).filter(prefix => !dataSourceBlockList.includes(prefix));
  const initialDataSourcePrefix = filteredDataSourceAllowList[0];
  const [searchFilterString, setSearchFilterString] = useState('');
  const [selectedDataSourcePrefix, setSelectedDataSourcePrefix] = useState(initialDataSourcePrefix);
  const [hasCacheCleared, setHasCacheCleared] = useState(false);
  const isFirstAction = (actionId === NEW_ACTION ? previousActionId || 0 : actionId) <= 0;
  const currentActionId = actionId === NEW_ACTION ? previousActionId : actionId;
  const dataSourceToQuery = selectedDataSourcePrefix === ACTION_OUTPUTS ? {
    prefix: selectedDataSourcePrefix,
    options: {
      query: {
        currentActionId
      }
    }
  } : {
    prefix: selectedDataSourcePrefix
  };
  const {
    data: dataSource,
    loading,
    error: dataSourceError,
    refetch: refetchDataSource
  } = useGetDataSource(dataSourceToQuery);
  const {
    toObjectTypeId
  } = useGetDataSourceFromToObjectId(dataSourceToQuery);
  const isCreatePropertyBtnVisible = !isEmbedded && selectedDataSourcePrefix !== ACTION_OUTPUTS && selectedDataSourcePrefix !== ENROLLMENT_EVENTS && supportsCustomProperties(toObjectTypeId);

  // DEV NOTE: Flush the cache to invalidate top level containers that could have changed. This
  // addresses having a cached call, then adding new actions, enrollment events or fetched objects that have caused the cache to go stale.
  useEffect(() => {
    clearTopLevelDataSourceCaches();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (!lastAddedEditedDataSource) {
      return;
    }
    setHasCacheCleared(false);
    // DEV NOTE: Resolve a race condition using the next animation frame.
    requestAnimationFrame(() => clearTopLevelDataSourceCaches());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lastAddedEditedDataSource]);
  useEffect(() => {
    if (!lastDeletedDataSource || selectedDataSourcePrefix !== lastDeletedDataSource) {
      return;
    }
    setSelectedDataSourcePrefix(initialDataSourcePrefix);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lastDeletedDataSource]);
  useEffect(() => {
    if (!searchForDataToken || !clearSearchForDataToken) {
      return;
    }
    const {
      prefix,
      propertyLabel
    } = searchForDataToken;
    setSelectedDataSourcePrefix(prefix.startsWith(ACTION_OUTPUTS) ? ACTION_OUTPUTS : prefix);
    setSearchFilterString(propertyLabel);
    clearSearchForDataToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchForDataToken]);
  function clearTopLevelDataSourceCaches() {
    dataFetchingClient.cache.evict({
      fieldName: GET_DATA_SOURCE_BY_PREFIX_FIELD_NAME,
      broadcast: true,
      args: {
        flowId,
        flowObjectTypeId,
        prefix: ENROLLMENT_EVENTS,
        query: {}
      }
    });
    dataFetchingClient.cache.evict({
      fieldName: GET_DATA_SOURCE_BY_PREFIX_FIELD_NAME,
      broadcast: true,
      args: {
        flowId,
        flowObjectTypeId,
        prefix: FETCHED_OBJECTS,
        query: {}
      }
    });
    dataFetchingClient.cache.evict({
      fieldName: GET_DATA_SOURCE_BY_PREFIX_FIELD_NAME,
      broadcast: true,
      args: {
        flowId,
        flowObjectTypeId,
        prefix: ACTION_OUTPUTS,
        query: {
          currentActionId
        }
      }
    });
    dataFetchingClient.cache.evict({
      fieldName: GET_DATA_SOURCES_BY_PREFIX_FIELD_NAME,
      broadcast: true
    });
    dataFetchingClient.cache.gc();

    // DEV NOTE: This useState resolves a race condition where apollo
    // was querying one frame before we could clear out the cache on downline
    // components. With this useState we block downline rendering till we can
    // say the cache has been cleared out
    setHasCacheCleared(true);
  }
  const itemsSelectDisabled = !onDataPropertySelected;
  const handleDataSourceSearch = value => {
    trackEvent(usageTracker, Trackables.SEARCH_DATA_PANEL_PROPERTIES, {
      screen: 'Data panel revised UX',
      search: value
    });
    setSearchFilterString(value);
  };
  const handleOnChangeSelectedDataSource = prefix => {
    setSearchFilterString('');
    setSelectedDataSourcePrefix(prefix);
  };
  const handleRefetchDataSource = () => {
    // eslint-disable-next-line no-empty
    refetchDataSource().catch(() => {});
  };
  const handleDataPropertySelected = (dataProperty, dataSourceDefinition, dataCoordinate) => {
    trackEvent(usageTracker, Trackables.CLICK_DATA_PASSING_PANEL_DATA_SOURCE, {
      screen: 'Data Passing Panel',
      source: dataSourceDefinition.name === 'enrolled_object' ? 'ENROLLED_OBJECT' : dataSourceDefinition.dataSourceType,
      flowObjectTypeId,
      flowId,
      objectTypeIdSelected: getToObjectType(dataSourceDefinition, flowObjectTypeId)
    });
    onDataPropertySelected({
      dataProperty,
      dataSourceDefinition,
      dataCoordinate
    });
  };
  const handleOnCreateProperty = property => {
    const {
      label
    } = property;
    handleRefetchDataSource();
    setSearchFilterString(label);
  };
  if (!hasCacheCleared) {
    return /*#__PURE__*/_jsx(UILoadingSpinnerCentered, {});
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(View, {
      borderBlockEndStyle: "solid",
      borderBlockEndWidth: "100",
      borderBlockEndColor: "border-core-default",
      paddingInline: "500",
      paddingBlockEnd: "300",
      children: /*#__PURE__*/_jsx(DataPassingPanelHeader, {
        flowObjectTypeId: flowObjectTypeId,
        isAddDataSourceBtnVisible: isAddDataSourceBtnVisible,
        isEmbedded: isEmbedded,
        isFirstAction: isFirstAction,
        onChangeSelectedDataSource: handleOnChangeSelectedDataSource,
        onClosePanelClick: onClosePanelClick,
        onDataSourceSearch: handleDataSourceSearch,
        openFetchObjectPanel: openFetchObjectPanel,
        searchFilterString: searchFilterString,
        dataSource: dataSource,
        selectedDataSourcePrefix: selectedDataSourcePrefix,
        lastAddedEditedDataSource: lastAddedEditedDataSource,
        lastDeletedDataSource: lastDeletedDataSource,
        dataSourceAllowList: filteredDataSourceAllowList
      })
    }), /*#__PURE__*/_jsx(ScrollContainer, {
      scrollDirection: "vertical",
      "data-test-id": "data-panel-data-sources",
      paddingBlock: "300",
      children: /*#__PURE__*/_jsx(DataPassingPanelBody, {
        actionId: actionId,
        dataSource: dataSource,
        dataSourceError: dataSourceError,
        disabled: itemsSelectDisabled,
        dataSourceAllowList: dataSourceAllowList,
        propertyFieldTypeAllowList: propertyFieldTypeAllowList,
        propertyTypeAllowList: propertyTypeAllowList,
        requiredPermissionLevel: requiredPermissionLevel,
        flowId: flowId,
        hideNestedDataSources: hideNestedDataSources,
        isEmbedded: isEmbedded,
        isFirstAction: isFirstAction,
        loading: loading,
        onDataPropertySelected: handleDataPropertySelected,
        searchFilterString: searchFilterString,
        selectedDataSourcePrefix: selectedDataSourcePrefix,
        refetchDataSource: handleRefetchDataSource
      })
    }), isCreatePropertyBtnVisible && toObjectTypeId && /*#__PURE__*/_jsx(DataPanelCreatePropertyButton, {
      objectTypeId: toObjectTypeId,
      onPropertyCreated: handleOnCreateProperty
    })]
  });
};
export default DataPanelRevisedUXMode;